'use client'
import React, { useRef, useState } from 'react'
import type { ISearchExploreSpot } from 'type/feed'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { normalizeAsset } from 'util/normalizeAsset'
import { formatMediaThumbnailType } from 'util/comment'
import Thumbnail from 'component/block/thumbnail'
import cn from 'util/cn'
import Link from 'next/link'
import VideoSpotlightsLoading from 'component/block/loading/video-spotlights-loading'

interface IVideoSpotlightsProp {
  spots: ISearchExploreSpot[]
  loading: boolean
}

const VideoSpotlights = ({ spots, loading }: IVideoSpotlightsProp) => {
  const [index, setIndex] = useState(0)
  const sliderRef = useRef<Slider>(null)
  const SIZE = 3

  const settings = {
    accessibility: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: SIZE,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>
  }

  if (loading)
    return (
      <>
        <VideoSpotlightsLoading />
      </>
    )

  return (
    <div className='relative'>
      {index !== 0 && (
        <div
          className=' absolute top-1/2 left-[24px] -translate-y-1/2 z-10 bg-glass_special-tips size-[32px] flex justify-center items-center rounded-full cursor-pointer'
          onClick={e => {
            e.stopPropagation()
            sliderRef?.current?.slickPrev()
          }}
        >
          <div className='i-ps-chevron_left [--icon-size:20px] text-primary-on_primary' />
        </div>
      )}

      <Slider
        ref={sliderRef}
        {...settings}
        afterChange={currentSlide => {
          setIndex(currentSlide)
        }}
      >
        {spots.map((post, index) => {
          const { src } = normalizeAsset(post?.asset)
          return (
            <div key={`${post.id}_${index}`} className={cn('relative')}>
              <Link
                key={`${post.id}_${index}`}
                href={`/post/${post.id}`}
                className={cn(
                  'relative block left-0  h-[180px] w-[120px]  min560:h-[228px] min560:w-[152px] min768:h-[285px] min768:w-[190px]  overflow-hidden rounded-xl'
                )}
              >
                <Thumbnail
                  url={src}
                  desc={post.description}
                  thumbnailType={formatMediaThumbnailType(post.asset)}
                  locationName={post.place.location.display_name}
                  counts={post.count}
                />
              </Link>
            </div>
          )
        })}
      </Slider>

      {index < spots.length - SIZE && (
        <div
          className=' absolute top-1/2 right-[24px] -translate-y-1/2 z-10 bg-glass_special-tips size-[32px] flex justify-center items-center rounded-full cursor-pointer'
          onClick={e => {
            e.stopPropagation()
            sliderRef?.current?.slickNext()
          }}
        >
          <div className='i-ps-chevron_right [--icon-size:20px] text-primary-on_primary' />
        </div>
      )}
    </div>
  )
}

export default VideoSpotlights
